'use client'

import { Toaster as Sonner, type ToasterProps } from 'sonner'

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      toastOptions={{
        classNames: {
          toast:
            'group font-serif bg-background text-foreground border border-border shadow-lg',
          success:
            'bg-[hsl(var(--toast-success-bg))]! text-[hsl(var(--toast-success-text))]! border-[hsl(var(--toast-success-border))]!',
          error:
            'bg-[hsl(var(--toast-error-bg))]! text-[hsl(var(--toast-error-text))]! border-[hsl(var(--toast-error-border))]!',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
